var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "296px",
    viewBox: "0 0 256 296",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.8995881%",
    y1: "100.003488%",
    x2: "49.8995881%",
    y2: "0.00311374074%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37C27",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3774",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.8165779,207.36323 L24.8165779,88.229422 L127.997263,28.6488313 L127.997263,147.788114 L231.183422,88.229422 L231.183422,207.36323 L127.997263,266.943821 L24.8165779,207.36323 L24.8165779,207.36323 Z M115.591711,7.14441522 L12.4110263,66.7195312 L0,73.8967943 L0,88.2348966 L0,207.368705 L0,221.717756 L12.4110263,228.88407 L115.597186,288.464661 L127.997263,295.630975 L140.413764,288.453711 L243.594448,228.873121 L256,221.706807 L256,207.357755 L256,88.229422 L256,73.8913197 L243.594448,66.7140566 L140.413764,7.14441522 L127.997263,0 L115.591711,7.14441522 L115.591711,7.14441522 Z",
    fill: "url(#linearGradient-1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeap);
export default __webpack_public_path__ + "static/media/heap.50519a6e36d0d10106e51cc5df556115.svg";
export { ForwardRef as ReactComponent };